module.exports = __webpack_public_path__ + "static/media/donasi-white.e8eba695.svg";


//////////////////
// WEBPACK FOOTER
// ./src/component/donasi-white.svg
// module id = 366
// module chunks = 2